<template>
  <v-app id="contact_form">
    <v-alert v-model="alertStatus" dismissible type="success">This form was submitted successfully.</v-alert>
    <v-container grid-list-xl>
      	<v-layout wrap align-center>
				<v-flex xs12 sm6 d-flex>
					<v-select
						v-model="data.to"
						v-validate="'required'"			
						:error-messages="errors.collect('to')"
						:items="people"
						label="To"
						item-text="text"
						item-value="value"
						:append-icon-cb="closeMenu"
						ref="to"
						dense
					>					
						<template slot="selection" slot-scope="data">{{ data.item.text }}</template>
						<template slot="item" slot-scope="data" >
							<template v-if="typeof data.item !== 'object'">
								<v-list-tile-content v-text="data.item"></v-list-tile-content>
							</template>
							<template v-else>
								<v-list-tile-content>
								<v-list-tile-title v-html="data.item.text"></v-list-tile-title>
								</v-list-tile-content>
							</template>
						</template>
					</v-select>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.from"
            v-validate="'required|max:20'"
            :counter="20"
            :error-messages="errors.collect('from')"
            data-vv-name="from"
            required
            label="From"
          ></v-text-field>
        </v-flex>
		</v-layout>
		<v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            data-vv-name="email"
            required
            label="Email"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.subject"
            v-validate="'required|max:50'"
            :counter="50"
            :error-messages="errors.collect('subject')"
            data-vv-name="subject"
            required
            label="Subject"
          ></v-text-field>
        </v-flex>
		</v-layout>
		<v-layout wrap align-center>
        <v-flex xs12 sm12 d-flex>
          	<v-textarea name="input-7-1" label="Message" v-model="data.message"></v-textarea>
        </v-flex>
		</v-layout>
		<vue-recaptcha sitekey="6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8">
        	<v-btn color="primary" dark @click.prevent="submitForm1">Send Email</v-btn>
      	</vue-recaptcha>
    </v-container>
  </v-app>
</template>


<script>
import VueRecaptcha from "vue-recaptcha";
export default {
	name: "form1",
	components: { VueRecaptcha },
	$_veeValidate: {
		validator: "new"
	},
	data: () => ({
		data: {
			to: "sales@kencove.com",
			from: "",
			subject: "",
			message: "",
			email: "",
		},
		alertStatus: false,
		people: [
			{text: "Sales", value: "sales@kencove.com" },
			{text: "Customer Service", value: "customerservice@kencove.com" },
			{text: "Accounting", value: "ar@kencove.com" },
			{text: "Human Resources", value: "hr@kencove.com" }
		]
	}),
	mounted() {
		this.$validator.localize("en", this.dictionary);
	},
	methods: {
		submitForm1() {
			this.$validator.validateAll().then(valid => {
				console.log(this.data);
				if (valid) {
					this.alertStatus = this.$store.dispatch("submitForm1", this.data);
				}
			});
		},
		closeMenu() {
			if(this.$refs.to.isMenuActive == true) this.$refs.to.isMenuActive = false;
			else this.$refs.to.isMenuActive = true;
		}
	}
};
</script>



// WEBPACK FOOTER //
// contact_form.vue?49bf83c4